const TimeClock = () => {
  return <>Timeclock Page</>;
};

export default TimeClock;
